/* Maison Bassano — lightweight progressive enhancements */
(() => {
  'use strict';

  document.documentElement.classList.add('js');

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const state = { observer: null, ticking: false };

  const reveal = (root = document) => {
    const elements = root.querySelectorAll('[data-mb-reveal]:not(.mb-reveal-ready)');
    if (!elements.length) return;

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('mb-reveal-ready', 'mb-visible'));
      return;
    }

    if (!state.observer) {
      state.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('mb-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }

    elements.forEach((element) => {
      element.classList.add('mb-reveal-ready');
      state.observer.observe(element);
    });
  };

  const createProgress = () => {
    if (document.querySelector('.mb-scroll-progress')) return;
    const progress = document.createElement('div');
    progress.className = 'mb-scroll-progress';
    progress.setAttribute('aria-hidden', 'true');
    document.body.appendChild(progress);
  };

  const createBackToTop = () => {
    if (document.querySelector('.mb-back-to-top')) return;
    const button = document.createElement('button');
    button.className = 'mb-back-to-top';
    button.type = 'button';
    button.setAttribute('aria-label', 'Revenir en haut de la page');
    button.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" width="21" height="21" fill="none"><path d="m6 14 6-6 6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' }));
    document.body.appendChild(button);
  };

  const updateScrollUI = () => {
    state.ticking = false;
    const top = window.scrollY || document.documentElement.scrollTop;
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const progress = document.querySelector('.mb-scroll-progress');
    const backToTop = document.querySelector('.mb-back-to-top');
    const header = document.querySelector('.section-header');

    if (progress) progress.style.width = `${Math.min(100, (top / max) * 100)}%`;
    if (backToTop) backToTop.classList.toggle('is-visible', top > 700);
    if (header) header.classList.toggle('mb-header-scrolled', top > 24);
  };

  const onScroll = () => {
    if (state.ticking) return;
    state.ticking = true;
    window.requestAnimationFrame(updateScrollUI);
  };

  const initExternalLinks = (root = document) => {
    root.querySelectorAll('a[data-mb-external]').forEach((link) => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  };

  const init = (root = document) => {
    reveal(root);
    initExternalLinks(root);
    createProgress();
    createBackToTop();
    updateScrollUI();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:reorder', () => updateScrollUI());
})();
